import {
  IMobileUser as IBEMobileUser,
  IWebUser as IBEWebUser,
} from "fieldpro-tools/dist/src/types";

import { CLEAR_KEYWORD } from "api/constants";
import { IMobileUser, IWebUser } from "model/entities/User";

export const prepareMobileUserForBackend = (
  mobileUser: IMobileUser,
): Partial<IBEMobileUser> => {
  const result: Partial<IBEMobileUser> = { ...(mobileUser as any) };
  Object.keys(result).forEach((att) => {
    // @ts-expect-error TS7053
    if (result[att] === "" || result[att] === null) {
      // @ts-expect-error TS7053
      delete result[att];
    }
  });

  delete mobileUser.user_start_location;
  delete (mobileUser as any).user_start_location__lat;
  delete (mobileUser as any).user_start_location__lng;
  delete (mobileUser as any).user_start_location__acc;
  return result;
};

export const prepareWebUserForFrontend = (webUser: IBEWebUser): IWebUser => {
  const result: IWebUser = { ...(webUser as any) } as IWebUser;
  return result;
};

export const prepareWebUserForBackend = (webUser: IWebUser): IBEWebUser => {
  const result: IBEWebUser = { ...(webUser as any) } as IBEWebUser;
  Object.keys(result).forEach((att) => {
    // @ts-expect-error TS7053
    if (result[att] === "" || result[att] === null || att === "middle_name") {
      // @ts-expect-error TS7053
      delete result[att];
    }
    if (att === "email") {
      result[att] = result[att].toLowerCase();
    }
  });
  return result;
};

export const removeClearKeyword = (user: IMobileUser): IMobileUser => {
  const result = Object.fromEntries(
    Object.entries(user).map(([key, value]) => [
      key,
      value === CLEAR_KEYWORD ? "" : value,
    ]),
  ) as IMobileUser;

  return result;
};
